import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Landing.css';

export default function Landing(props) {
    const { profile = {}, sucursal_id } = props;
    const sucursales = profile.sucursales;
    const sucursal = sucursales?.find(
        sucursal => sucursal.sucursal_id === sucursal_id,
    );
    const qrCode = 'images/qr-demo-nb-landing.png';
    useEffect(() => {
        console.log('Landing');
    }, []);

    return (
        <div className="landing-container">
            <div className="landing-content">
                <div className="landing-text">
                    <h1>¡Bienvenido{profile.first_name ? `, ${profile.first_name} ${profile.last_name ? ` ${profile.last_name}` : ''}` : ''}! <span className="value-prop">Gestiona tus chatbots en segundos</span></h1>
                    <p className="subtitle">Centro de control para <span className="highlight">{profile.tenant_name || 'tu negocio'} {sucursal.sucursal_name ? ` - ${sucursal.sucursal_name}` : ''}</span></p>
                    <p className="description">
                        Monitorea y responde tus chatbots de WhatsApp desde un solo lugar.
{'\n'}Consulta métricas en tiempo real, responde mensajes o pruébalos al instante.
                    </p>
                    
                    <h2 className="how-to-start">¿Cómo comenzar?</h2>
                    
                    <div className="features-compact">
                        <div className="feature-item">
                        <div className="feature-icon">📊</div>
                            <div className="feature-content">
                                <h3>Dashboard de estadísticas</h3>
                                <p>Visualiza métricas en tiempo real</p>
                            </div>
                        </div>
                        <div className="feature-item">
                        <div className="feature-icon">💬</div>
                            <div className="feature-content">
                                <h3>Gestión de mensajes</h3>
                                <p>Revisa y responde los mensajes de tus usuarios</p>
                            </div>
                        </div>
                        <div className="feature-item">
                            <div className="feature-icon">🧪</div>
                            <div className="feature-content">
                                <h3>Prueba tu chatbot</h3>
                                <p>Escanea el QR para interactuar con tu bot</p>
                            </div>
                        </div>
                    </div>
                    
                    <div className="admin-buttons">
                        <Link to="/dashboard">
                            <button className="admin-button dashboard-btn">Ir al Dashboard</button>
                        </Link>
                        <Link to="/chats">
                            <button className="admin-button chat-btn">Abrir bandeja de mensajes</button>
                        </Link>
                    </div>
                </div>
                <div className="qr-section">
                    <div className="qr-container">
                        <p className="qr-title">¿Quieres probar tu bot en WhatsApp?</p>
                        <img src={qrCode} alt="Código QR para probar el chatbot" className="qr-code" />
                        <p className="qr-instruction">Probar chatbot ahora</p>
                        <p className="qr-subtitle">Escanea este código con tu celular</p>
                        <div className="branding">Powered by Robnett</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
